import Contacts from './contacts.vue'
export default Contacts